/**
 * Insurance tracking events for RBC flight checkout
 */

// Raw event names
export enum InsuranceRawEventName {
  ViewedInsurance = "ViewedInsurance",
  ViewedInsuranceTerms = "ViewedInsuranceTerms",
  SelectedInsurance = "SelectedInsurance",
}

// Amplitude event names
export enum InsuranceEventName {
  viewed_insurance = "viewed_insurance",
  viewed_insurance_terms = "viewed_insurance_terms",
  selected_insurance = "selected_insurance",
}

// Raw events
export interface ViewedInsuranceRawEvent {
  name: InsuranceRawEventName.ViewedInsurance;
  properties: {
    /** Array of available policy codes */
    policies_available: string[];
  };
}

export interface ViewedInsuranceTermsRawEvent {
  name: InsuranceRawEventName.ViewedInsuranceTerms;
  properties: {
    /** Policy code for which terms are being viewed */
    insurance_policy: string;
  };
}

export interface SelectedInsuranceRawEvent {
  name: InsuranceRawEventName.SelectedInsurance;
  properties: {
    /** Selected policy code or 'declined' */
    insurance_policy: string;
    /** Total insurance cost (premium + tax) */
    insurance_policy_total?: number;
  };
}

// Amplitude events
export interface ViewedInsuranceEvent {
  name: InsuranceEventName.viewed_insurance;
  properties: {
    /** Number of policies available */
    policies_available: number;
  };
}

export interface ViewedInsuranceTermsEvent {
  name: InsuranceEventName.viewed_insurance_terms;
  properties: {
    /** Policy code: classic_medical, non-medical, deluxe, cancellation_interruption, travel_within_canada */
    insurance_policy: string;
  };
}

export interface SelectedInsuranceEvent {
  name: InsuranceEventName.selected_insurance;
  properties: {
    /** Selected policy code or 'declined' */
    insurance_policy: string;
    /** Total insurance cost */
    insurance_policy_total?: number;
  };
}

// Union types
export type InsuranceRawEvent =
  | ViewedInsuranceRawEvent
  | ViewedInsuranceTermsRawEvent
  | SelectedInsuranceRawEvent;

export type InsuranceEvent =
  | ViewedInsuranceEvent
  | ViewedInsuranceTermsEvent
  | SelectedInsuranceEvent;
